import { Fade, Modal } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import { FC, ReactNode, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useActions } from '../../../hooks/useActions';
import { useBasket } from '../../../hooks/useBasket';

import styles from './Checkout.module.sass';
import { useCheckout } from './useCheckout';

interface ICheckoutDialog {
  content: ReactNode;
}

const CheckoutDialog: FC<ICheckoutDialog> = ({ content }) => {
  const { setValue } = useFormContext();
  const { modalVisible } = useBasket();
  const { setHandleModal } = useActions();
  const handleModal = () => {
    setHandleModal(!modalVisible);
  };
  return (
    <Modal
      keepMounted
      onClose={handleModal}
      open={modalVisible}
      closeAfterTransition
    >
      <Fade in={modalVisible} timeout={400}>
        <div className={styles.modal}>{content}</div>
      </Fade>
    </Modal>
  );
};

export default CheckoutDialog;
